import { Component, forwardRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { formfiledType } from '../../types/formtype';

@Component({
  selector: 'app-custom-input',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, InputTextModule, PasswordModule,FormsModule],
  templateUrl: './customInput.component.html',
  styleUrl: './customInput.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomInputComponent),
      multi: true,
    },
  ],
})
export class CustomInputComponent implements ControlValueAccessor {
  @Input() label!: string;
  @Input() id!: string;
  @Input() type!: formfiledType;
  @Input() placeholder = '';

  value = '';
  disabled = false;

  // 🔹 Angular يمرر دوال هنا أثناء الربط
  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  // ✅ Angular → component
  writeValue(value: any): void {
    this.value = value ?? null;
  }

  // ✅ component → Angular
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

onValueChange(event: Event): void {
  const input = event.target as HTMLInputElement; //  هنا بتقولي ل TypeScript إنه input فعلاً
  const newValue = input?.value ?? ''; //  لو null، خليه string فاضي بدل ما يوقع الخطأ
  this.value = newValue;
  this.onChange(newValue);
}
  onBlur(): void {
    this.onTouched();
  }
}
